import React from 'react';
import { LockIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const privacyFeatures = [{
  number: '1',
  title: 'No Storage or Selling',
  description: 'Emigo does not store or sell your messages and has no access to your chat history or what others send you. It only processes what you type or upload, such as screenshots you choose to analyze, when you actively use features like Reframe or Interpret. You do not need to create an account or provide personal information to use Emigo, and your text is processed anonymously in secure, temporary sessions. If you are not using a feature, Emigo stays completely offline.'
}, {
  number: '2',
  title: 'Anonymous Processing',
  description: "Every message sent through Emigo, yours and everyone else's, is processed anonymously. They all flow through the same channel, with no way to tell who sent what."
}, {
  number: '3',
  title: 'Opt-Out by Default',
  description: 'By default, you are opted out of all data sharing with Emigo itself. When you use a feature, your text is transmitted securely to our trusted technology partner to help Emigo analyze and generate responses. This data is handled under strict confidentiality and security measures and is not used to identify you.'
}, {
  number: '4',
  title: 'Future Optional Features',
  description: 'In the future, we may introduce optional features such as emotional insights or personalized analytics that require limited data retention. These will always be opt-in, and you will have full control over what you share. You can delete any stored data at any time, and uninstalling the app clears all local data immediately.'
}];
const PrivacyCard = ({
  feature,
  index
}) => {
  return <div className="group bg-white rounded-2xl p-6 border-2 border-[#E87B5C]/30 hover:border-[#E87B5C]/50 transition-all duration-300 h-full flex flex-col" style={{
    animationDelay: `${index * 100}ms`
  }} data-id="element-463">
      <div className="relative flex flex-col h-full" data-id="element-464">
        {/* Number Badge and Title - Side by side */}
        <div className="flex items-center gap-4 mb-4" data-id="element-465">
          <div className="w-12 h-12 rounded-xl bg-[#E87B5C]/10 flex items-center justify-center group-hover:bg-[#E87B5C]/20 transition-all duration-300 flex-shrink-0" data-id="element-466">
            <span className="text-xl font-bold text-[#E87B5C]" data-id="element-467">
              {feature.number}
            </span>
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-[#E87B5C] group-hover:text-[#D16A4A] transition-colors duration-300" data-id="element-468">
            {feature.title}
          </h3>
        </div>

        {/* Description */}
        <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-469">
          {feature.description}
        </p>
      </div>
    </div>;
};
const PrivacySection = () => {
  const navigate = useNavigate();
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#FFF5EB]" data-id="element-470">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-471">
        <div className="text-center mb-12" data-id="element-472">
          <h2 className="text-3xl md:text-4xl font-bold text-[#E87B5C]" data-id="element-473">
            Your Privacy Comes First
          </h2>
          <p className="mt-4 text-xl text-[#E87B5C]/80" data-id="element-474">
            Your words stay private.
          </p>
        </div>

        {/* Privacy Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-475">
          {privacyFeatures.map((feature, index) => <PrivacyCard key={index} feature={feature} index={index} data-id="element-476" />)}
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mt-8" data-id="element-477">
          <button onClick={() => navigate('/privacy-policy')} className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-br from-[#E87B5C] to-[#D16A4A] text-white font-medium hover:opacity-90 transition-all shadow-sm hover:shadow-md" data-id="element-478">
            <LockIcon className="w-5 h-5 mr-2" data-id="element-479" />
            See our full privacy policy here
          </button>
        </div>
      </div>
    </section>;
};
export default PrivacySection;